module.exports = __webpack_public_path__ + "img/agingcare.4ff6f24e.png";